$(document).ready(function() {
	$('#forgotModal').modal({
		show : false
	});
	$("#formLogin").validate();
	$("#formRegister").validate();
	$("#emailForm").validate();

	if(LoginRegister.wrongSite && LoginRegister.siteRedirectHost != "" && LoginRegister.siteRedirectCUI != ""){
		wrongSiteReDirect(LoginRegister.siteRedirectHost, LoginRegister.siteRedirectCUI, LoginRegister.rememberMe);
	}
	
	if(LoginRegister.containsGoogle=="true"){
		initClient(LoginRegister.googleId);
	}
	
	$(".submitEmail").click(function(){
		var isvalid = $("#formRegister").valid();
		if (!isvalid) {
			return false;
		}
		
		var isEmailValid = emailValidation('registerMail');
		if (!isEmailValid) {
			return false;
		}
		
		if (grecaptcha.getResponse().length == 0) {
			alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
			return false;
		}
		
		var agreeChecked = $("#loginagree").prop("checked");
		if (!agreeChecked) {
			alert(FmtMessage.getMessage('js.social.agreement.check.warning'));
			return;
		}else{
			$('#formRegister').submit();
		}
	});
	
	$(".fbButton").click(function(){
		
		FB.getLoginStatus(function(response) {
			
			if (response.status === 'connected') {
				 FB.api('/me?fields=id,first_name,last_name,email,birthday,gender,location', function(response) {
			        var gender = response.gender;
					if(gender == 'male'){
						gender = 1;
					} else if (gender == 'female'){
						gender = 2;
					}
			       loginSocialNetworkUser(response.id,"facebook",response.email,response.first_name,response.last_name,gender,response.birthday,null);
			     });
// 						doLogin(response.authResponse);				
			} else {
				FB.login(function(response){
					FB.api('/me?fields=id,first_name,last_name,email,birthday,gender,location', function(response) {
				        var gender = response.gender;
						if(gender == 'male'){
							gender = 1;
						} else if (gender == 'female'){
							gender = 2;
						}
				      loginSocialNetworkUser(response.id,"facebook",response.email,response.first_name,response.last_name,gender,response.birthday,null);
				    });
// 							doLogin(response.authResponse);	
				},
				{scope: 'email,user_birthday'});
			}
			
		});
		
	});
	
	$("#formRegister").letterCase($.cookie('siteLocale')).validate();
	
	//Strong Password
	$('.password-container').pschecker({ onPasswordValidate: validatePassword, onPasswordMatch: matchPassword });
	
	var submitbutton = $('.submit-button');
	var errorBox = $('.error');
	errorBox.css('visibility', 'hidden');
	submitbutton.attr("disabled", "disabled");

    //this function will handle onPasswordValidate callback, which mererly checks the password against minimum length
    function validatePassword(isValid) {
        if (!isValid) {
            errorBox.css('visibility', 'visible');
        } else {
        	errorBox.css('visibility', 'hidden');
    	}
    }
    //this function will be called when both passwords match
    function matchPassword(isMatched) {
        if (isMatched) {
            submitbutton.addClass('unlocked').removeClass('locked');
            submitbutton.removeAttr("disabled", "disabled");
        } else {
            submitbutton.attr("disabled", "disabled");
            submitbutton.addClass('locked').removeClass('unlocked');
        }
    }
});

function showEmailSendDialog() {
	$('#forgotModal').modal('show');
}

window.fbAsyncInit = function() {
	FB.init({
		appId : LoginRegister.facebookId,
		status : true,
		cookie : true,
		xfbml : true,
		oauth : true
	});
		
	if (window.location.pathname == "/logout") {

		function handleSessionResponse(response) {
			if (response.status != "connected") {
				window.location = window.location.protocol + "//"
						+ window.location.host;
			}

			// if we do have a non-null response.session, call FB.logout(),
			// the JS method will log the user out of Facebook and remove any
			// authorization cookies
			
			//logout removed C.Enc
			//FB.logout(handleSessionResponse);
			return;
		}
		
		FB.getLoginStatus(handleSessionResponse);
	} else {
		
/* 		if (autoLogin) {
		FB.getLoginStatus(function(response) {

			if (response.status == 'connected') {
				doLogin(response.authResponse);
			} else if (response.status == 'not_authorized') {
			} else {

				
				FB.Event.subscribe('auth.login', function(response) {
					if (response.status == 'connected') {
						
						doLogin(response.authResponse);
					}
				});
			   }
			
		}, true);
		 } */

	}
}

function loginSocialNetworkUser(snUserId,snKey,email,name,surname,gender,birthdate, inviteUserId){
	
	$.ajax({
		url : '/login/socialNetwork',
		dataType : "json",
		type : 'POST',
		data : {
			snUserId: snUserId,
			snKey: snKey,
			email:  email,
			name: name,
			surname: surname,
			gender: gender,
			birthdate: birthdate,
			inviteUserId: inviteUserId
		},
		success : function(data) {
			var user = data.user;
			var result = data.result;
			
			if(result != "true"){
				return;
			}else if(data.errorCode == "20210"){
				var redirectHostName = "";
				if(user && user.defaultHostName ){			
					var preCodeHostName = "";
					if(window.location.host.indexOf("aerobilet.") > -1){
						preCodeHostName = window.location.host.substr(0,window.location.host.indexOf("aerobilet."))
					}
					redirectHostName = preCodeHostName + user.defaultHostName;
				}
				var alertText = "<p class='alert' style='color: red;'><fmt:message key='error.login.wrongSite'> ";
				alertText = alertText + "<fmt:param><a href='https://" + redirectHostName + "'>" + redirectHostName + "</a></fmt:param>";
				alertText = alertText + "</fmt:message></p>";
				$("#loginError").html(alertText);
				if(user && user.defaultHostName ){
					wrongSiteReDirect(user.defaultHostName, user.cookieUserId, true)
				}
				return;
			} else if (user) {
				window.location =  "/workplace";
			} else { //registerUser
				
				$("#email-form-"+snKey).dialog({
					autoOpen: false,
					modal: true,
					show: "fade",
					hide: "fade",
					 buttons: {
						 "<fmt:message key='vkontakte.email.send' />": function() {
							 if($("#email-form-"+snKey).find("#email").validate()){
									email = $("#email-form-"+snKey).find("#email").val();	
									loginSocialNetworkUser(snUserId,snKey,email,name,surname,gender,birthdate, inviteUserId); //set email and retry login(register)
									$("#email-form-"+snKey).dialog("close");
								}
						 },
						 "<fmt:message key='vkontakte.email.cancel' />": function() {
							 $("#email-form-"+snKey).dialog("close");
						 }
					 }
				});
				
				$("#email-form-"+snKey).dialog("open");
				
			}
		},
		complete : function(xhr,status) {
			var a = 0;
		}
	});
	
}

function wrongSiteReDirect(siteRedirectHost, siteRedirectCUI, rememberMe){
    openRedirectLoaderBox(siteRedirectHost);
    if(siteRedirectHost){
        setTimeout(function(){
            var preCodeHostName = "";
            var host = window.location.host;
            
            // Only handle rafeef.com redirects
            if(host.indexOf("rafeef.") > -1){
                preCodeHostName = host.substr(0, host.indexOf("rafeef."));
                siteRedirectHost = "rafeef.com"; // Always redirect to rafeef.com
            }
            
            var pathName = "/login";
            window.location = window.location.protocol + "//" + preCodeHostName + siteRedirectHost + pathName +
                "?red_cui=" + siteRedirectCUI + "&red_rm=" + rememberMe;
            closeRedirectLoaderBox();
        }, 2000);
    }
}

function openRedirectLoaderBox(siteRedirectHost) {
    // Set the loading message if needed
    if (typeof LoginRegister !== 'undefined' && LoginRegister.dialogMessage) {
        $("#loading-head").html(LoginRegister.dialogMessage);
    } else {
        $("#loading-head").html('Redirecting, please wait...');
    }
    var $modal = $("#redirect-loadingbox");
    if ($modal.length && typeof bootstrap !== 'undefined') {
        var modalInstance = bootstrap.Modal.getOrCreateInstance($modal[0]);
        modalInstance.show();
    } else {
        $modal.show();
    }
}

function closeRedirectLoaderBox() {
    var $modal = $("#redirect-loadingbox");
    if ($modal.length && typeof bootstrap !== 'undefined') {
        var modalInstance = bootstrap.Modal.getOrCreateInstance($modal[0]);
        modalInstance.hide();
    } else {
        $modal.hide();
    }
}
